import { theme } from '@features/lci-report/domain/theme';
import { Slide, TableOptions } from '@features/powerpoint';

export type MinimumsTableData = {
  headers: string[];
  body: string[][];
};

type MinimumsTableProps = {
  options: TableOptions;
  data: MinimumsTableData;
};

export const minimumsTable = (props: MinimumsTableProps): Slide => {
  const { data, options } = props;

  return {
    tables: [
      {
        tableRows: [
          data.headers.map(header => ({
            text: header,
            options: { bold: true, color: theme.colors.inmarketGreen },
          })),
          ...data.body.map(row => row.map(cell => ({ text: cell }))),
        ],
        options: {
          autoPage: true,
          margin: 0,
          fontSize: 12,
          color: theme.colors.white,
          ...options,
        },
      },
    ],
  };
};
